import timeUtil from '../common/time-util'
import user from "./model/useInfor"
import {
  dataDst
} from "../common/util"
import kzWrodBook from './kzWordBook.json'
import PageDict from '../store/model/useInfor'
import kzCondition from './kz-condition/kz-condition'


let columns = {}
let channelData = []
let sourceData = []
let serviceData = []
let serviceGroupData = []
let shotData = new Map()
let attrData = new Map()
export const fGetColumns = (data, role) => {

  user.state.pageDict.commonMap.commonType.map(item => {
    shotData.set(`${item.dicCode}`, item)
  })
  if (user.state.pageDict.commonMap.attrId && user.state.pageDict.commonMap.attrId.length) {
    user.state.pageDict.commonMap.attrId.map(item => {
      attrData.set(`${item.dicCode}`, item)
    })
  }
  //获取页面表头筛选信息
  getChannelData()
  if (role) {
    columns[role] = getColumns(data.list, role)
  } else {
    data.forEach(item => {
      if (JSON.parse(item.titleTxt)) {
        columns[item.action] = getColumns(JSON.parse(item.titleTxt), item.action)
      } else {

      }
    })
  }

  return columns
}

//脱敏权限
const ifEncryption = row => {
  let encryptStats = false
  let encrypt = user.state.userCompany.notSelfBlind
  let userId = user.state.userInfo.id
  let permission = user.state.permissionMap
  if (encrypt && !permission['key129']) {
    if (parseInt(row.receptorid) !== parseInt(userId) && parseInt(row.promotorid) !== parseInt(userId) && parseInt(row.collectorid) !== parseInt(userId) && parseInt(row.appointorid) !== parseInt(userId)) {
      return encryptStats = true
    } else {
      return encryptStats = false
    }
  } else {
    return encryptStats = false
  }
}

//渲染表头数据
const getColumns = (data, role) => {
  let arr = []
  arr.push({
      type: 'selection',
      width: 30,
      align: 'center'
    }),
    data.forEach(item => {
      switch (item.key) {
        case 'index':
          handleIndex(arr, item)
          break;
        case 'id':
          handleId(arr, item)
          break;
        case 'adid':
          handleAdId(arr, item)
          break;
        case 'birthday':
          handleBirthday(arr, item)
          break;
        case 'letterid':
          handleLetterId(arr, item)
          break;
        case 'channelname':
          //渠道名称
          handleChannel(arr, item)
          break
        case 'sourcename':
          //来源名称
          hanleSourname(arr, item)
          break
        case 'yxlevel':
          //意向等级
          handleYxlevel(arr, item)
          break
        case 'kzphone':
          handlePhone(arr, item)
          break
        case 'kzww':
          handleWw(arr, item)
          break
        case 'wechat':
          handleWechat(arr, item, role)
          break
        case 'kzwechat':
          handleWechat(arr, item, role)
          break
        case 'kzqq':
          handleQq(arr, item)
          break
        case 'kzname':
          handleKzName(arr, item, role)
          break
        case 'typename':
          //拍摄类型
          handleTypeName(arr, item)
          break
        case 'oldkzname':
          //老客姓名
          handleOldKzName(arr, item)
          break
        case 'oldkzphone':
          //老客手机
          handleOldKzPhone(arr, item)
          break
        case 'marrytime':
          //备注婚期时间
          handleMarryTime(arr, item)
          break
        case 'yptime':
          //备注婚期时间
          handleYpTime(arr, item)
          break
        case 'memo':
          //备注描述
          handleMemo(arr, item)
          break
        case 'zxstyle':
          //咨询类型
          handleZxStyle(arr, item)
          break
        case 'collectorname':
          //推广姓名
          handleCollectorName(arr, item)
          break
        case 'deptsort':
          //客服组
          handleDeptsort(arr, item)
          break
        case 'groupname':
          //客服组
          handleDeptsort(arr, item)
          break
        case 'appointname':
          //客服姓名
          handleAppointName(arr, item)
          break
        case 'shopname':
          //门钉名称
          handleShopName(arr, item)
          break
        case 'statusname':
          //状态
          handleStatusName(arr, item, role)
          break
        case 'successtime':
          //订单时间
          handleSuccessTime(arr, item)
          break
        case 'tracetime':
          //下次追踪时间
          handleTracetimeTime(arr, item)
          break
        case 'paystyle':
          //付款方式
          handlePlayStyel(arr, item)
          break
        case 'amount':
          // 总套系金额
          handleAmount(arr, item)
          break
        case 'stayamount':
          //已收金额
          handleStayAmount(arr, item)
          break
        case 'createtime':
          handleCreateTime(arr, item)
          break
        case 'comeshoptime':
          handleComeshopTime(arr, item)
          break
        case 'receivetime':
          handleReceiveTime(arr, item)
          break
        case 'updatetime':
          handleUpdateTime(arr, item)
          break
        case 'appointtime':
          handleappintTime(arr, item)
          break
        case 'address':
          handleAddress(arr, item)
          break
        case 'htnum':
          handleHtnum(arr, item)
          break
        case 'button':
          handleOperation(arr, item)
          break
        case 'receptorname':
          //门市
          handleReceptorName(arr, item)
          break
        case 'adaddress':
          //地址
          handleAdAdress(arr, item)
          break
        case 'attrid':
          //地区
          handleAreaId(arr, item)
          break
        case '':
          break;
        default:
          handleElse(arr, item)
      }
    })
  return arr
}


//处理状态过滤
const filterStatus = (key, action) => {
  let classId = ''
  switch (action) {
    case 'all':
      classId = '0'
      break
    case 'new':
      classId = '1'
      break
    case 'trace':
      classId = '2'
      break
    case 'order':
      classId = '3'
      break
    case 'come':
      classId = '4'
      break
    case 'success':
      classId = '5'
      break
    case 'invalid':
      classId = '6'
      break
    case 'custom':
      classId = '7'
      break
  }

  let status = PageDict.state.pageDict.statusMap
  let filter = []

  for (let item in status) {
    if (classId == '0' && status[item].showFlag) {
      filter.push({
        value: status[item].statusId,
        label: status[item].statusName,
      })
    } else if (status[item].classId == classId && status[item].showFlag) {
      filter.push({
        value: status[item].statusId,
        label: status[item].statusName,
      })
    }
  }

  return filter
}


//处理咨询类型过滤
const filterZxStyle = () => {
  let zxStyle = PageDict.state.pageDict.commonMap.zxStyle
  let filter = []

  for (let item in zxStyle) {
    filter.push({
      value: zxStyle[item].dicCode,
      label: zxStyle[item].dicName,
    })
  }
  return filter
}

//处理姓名
const filterKzName = () => {
  return [{
      value: '1',
      label: '先生',
    },
    {
      value: '2',
      label: '女士',
    },
    {
      value: '0',
      label: '未知',
    },
  ]
}

//处理微信
const filterWeacht = () => {
  return [{
      value: '1',
      label: '已添上',
    },
    {
      value: '2',
      label: '未添上',
    },
    {
      value: '0',
      label: '未标记  ',
    },
  ]
}

//处理操作
const handleOperation = (arr, item) => {
  arr.push({
    title: item.title,
    key: item.key,
    width: parseInt(item.width),
    ellipsis: true,
    render: (h, params) => {
      return h('render-filter', {
        props: {
          filterData: params
        }
      })
    }
  })
}

// 处理编号 id
const handleId = (arr, item) => {
  arr.push({
    title: '编号',
    width: parseInt(item.width),
    key: item.key,
    render: (h, params) => {
      return h('span', params.row.id)
    }
  })
}
// 处理广告 id
const handleAdId = (arr, item) => {
  arr.push({
    title: '广告ID',
    width: parseInt(item.width),
    key: item.key,
    render: (h, params) => {
      return h('span', params.row.adid)
    }
  })
}

// 新增 id
const handleLetterId = (arr, item) => {
  arr.push({
    title: '编号',
    width: parseInt(item.width),
    key: item.key,
    render: (h, params) => {
      return h('span', params.row.letterid)
    }
  })
}

// 生日
const handleBirthday = (arr, item) => {
  arr.push({
    title: '生日',
    width: parseInt(item.width),
    key: item.key,
    render: (h, params) => {
      if (params.row.kzbirthday) {
        return h('span', timeUtil.getDate(params.row.kzbirthday))
      } else {
        return h('span', '')
      }
    }
  })
}

// 处理广告着陆页
const handleAdAdress = (arr, item) => {
  arr.push({
    title: '广告着陆页',
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    render: (h, params) => {
      return h('span', {
        attrs: {
          title: params.row.adaddress,
        }
      }, params.row.adaddress)
    }
  })
}

// 处理门市
const handleReceptorName = (arr, item) => {
  arr.push({
    title: '门市',
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'info.RECEPTORID',
  })
}

//处理编号 索引
const handleIndex = (arr, item) => {
  arr.push({
    title: '编号',
    width: parseInt(item.width),
    key: item.key,
    type: 'index',
  })
}

//获取页面表头筛选信息
const getChannelData = () => {
  console.log("请求获取表头筛选信息");

  window.vue.$http.get('page_config/get_page_filter_map', {
    params: {
      role: user.state.roleType
    }
  }).then(data => {
    console.log("成功获取到表头筛选信息");
    //初始化
    channelData.splice(0, channelData.length);
    sourceData.splice(0, sourceData.length);
    serviceData.splice(0, serviceData.length);
    serviceGroupData.splice(0, serviceGroupData.length);
    if (data.code == 100000) {
      if (data.data.dept.length) {
        data.data.dept.map(item => {
          serviceGroupData.push(item)
        })
      }
      if (data.data.appointer && data.data.appointer.length) {
        data.data.appointer.map(item => {
          serviceData.push(item)
        })
      }
      if (data.data.channel.length) {
        data.data.channel.map(item => {
          channelData.push(item)
        })
      }
      if (data.data.source.length) {
        data.data.source.map(item => {
          sourceData.push(item)
        })
      }
    } else {
      window.vue.$Message.error(data.msg)
    }
  })
  console.log("---" + columns);
}

//处理渠道
const handleChannel = (arr, item) => {
  let channelClass = false
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'info.CHANNELID',
    filters: channelData,
    className: channelClass ? 'filterDataClass' : '',
    filterMethod(value, row) {
      return row.channelid === value
    },
    filterRemote(data) {
      if (data && data.length && data.length != 0) {
        kzCondition.mutations.setFilterSql({
          name: 'info.CHANNELID',
          data
        })
        channelClass = true
      } else {
        kzCondition.mutations.setFilterSql(false, {
          name: 'info.CHANNELID'
        })
        channelClass = false
      }
      window.vue.$bus.emit('pull-kz-data');
    },
    render: (h, params) => {
      return h('render-channel', {
        props: {
          channelData: params,
        },
      })
    }
  })
}

//处理来源
const hanleSourname = (arr, item) => {
  let sourceClass = false
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'info.SOURCEID',
    filters: sourceData,
    className: sourceClass ? 'filterDataClass' : '',
    filterMethod(value, row) {
      return row.sourceid === value
    },
    filterRemote(data) {
      if (data && data.length && data.length != 0) {
        kzCondition.mutations.setFilterSql({
          name: 'info.SOURCEID',
          data
        })
        sourceClass = true
      } else {
        kzCondition.mutations.setFilterSql(false, {
          name: 'info.SOURCEID'
        })
        sourceClass = false
      }
      window.vue.$bus.emit('pull-kz-data');
    },
    render: (h, params) => {
      return h('render-source', {
        props: {
          sourceData: params,
        },
      })
    }
  })
}

//获取意向等级
const pushYxLevel = () => {
  let yxFilterData = user.state.pageDict.commonMap.yxLevel.slice(1)
  let data = []
  yxFilterData.map(item => {
    data.push({
      value: item.dicCode,
      label: item.dicName,
    })
  })
  return data
}

//处理意向等级
const handleYxlevel = (arr, item) => {
  let yxClassState = false
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'det.YXLEVEL',
    filters: pushYxLevel(),
    className: yxClassState ? 'filterDataClass' : '',
    filterMethod(value, row) {
      return row.yxlevel === value
    },
    filterRemote(data) {
      if (data && data.length && data.length != 0) {
        kzCondition.mutations.setFilterSql({
          name: 'det.yxlevel',
          data
        })
        yxClassState = true
      } else {
        kzCondition.mutations.setFilterSql(false, {
          name: 'det.yxlevel'
        })
        yxClassState = false
      }
      window.vue.$bus.emit('pull-kz-data');
    },
    render: (h, params) => {
      if (params.row.yxlevel && params.row.yxlevel != '0') {
        let yxLeveObj = user.getters.getYxlevel()
        return h('span', {}, yxLeveObj.get('key' + params.row.yxlevel))
      }
    }
  })
}

//处理电话
const handlePhone = (arr, item) => {
  let phoneClass = false
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'info.KZPHONE_FLAG',
    className: phoneClass ? 'filterDataClass' : '',
    filters: [{
        value: 0,
        label: '未拨打',
      },
      {
        value: 1,
        label: '已拨打',
      },
      {
        value: 2,
        label: '已接听',
      },
      {
        value: 3,
        label: '未接听',
      },
    ],
    filterMethod(value, row) {
      return row.kzphone === value
    },
    filterRemote(data) {
      if (data && data.length && data.length != 0) {
        kzCondition.mutations.setFilterSql({
          name: 'info.KZPHONE_FLAG',
          data
        })
        phoneClass = true
      } else {
        kzCondition.mutations.setFilterSql(false, {
          name: 'info.KZPHONE_FLAG'
        })
        phoneClass = false
      }
      window.vue.$bus.emit('pull-kz-data');
    },
    render: (h, params) => {
      if (params.row[item.key]) {
        return h('render-phone', {
          props: {
            phone: params,
            kzId: params.row.kzid,
            kzPhoneStatus: params.row.kzphoneflag,
            kzPhoneFlag: params.row['kzphone_flag'],
            encryption: ifEncryption(params.row),
          }
        })
      }
    }
  })
}

//处理旺旺
const handleWw = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    render: (h, params) => {
      let encryption = ifEncryption(params.row)
      if (params.row['kzww']) {
        if (encryption) {
          return h('span', {}, dataDst(params.row['kzww']))
        } else {
          return h('span', {}, params.row['kzww'])
        }
      }
    }
  })
}

//处理微信
const handleWechat = (arr, item) => {
  let wxClassState = false
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    filters: filterWeacht(),
    filterMultiple: true,
    sortable: 'custom',
    sortKey: 'info.KZWECHAT',
    className: wxClassState ? 'filterDataClass' : '',
    filterMethod(value, row) {
      return row.weflag === value
    },
    filterRemote(data) {
      if (data && data.length && data.length != 0) {
        kzCondition.mutations.setFilterSql({
          name: 'info.WEFLAG',
          data
        })
        wxClassState = true
      } else {
        kzCondition.mutations.setFilterSql(false, {
          name: 'info.WEFLAG'
        })
        wxClassState = false
      }
      window.vue.$bus.emit('pull-kz-data')
    },
    render: (h, params) => {
      if (params.row['kzwechat']) {
        return h('render-wechat', {
          props: {
            wechat: params,
            encryption: ifEncryption(params.row),
          }
        })
      }
    }
  })
}

//处理qq
const handleQq = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width) + 13,
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'info.KZQQ',
    render: (h, params) => {
      let row = params.row
      let ncryption = ifEncryption(params.row)
      if (ncryption) {
        return (h('span', {}, dataDst(row[item.key])))
      } else {
        return (h('span', {}, row[item.key]))
      }
    }
  })
}

//处理客资姓名
const handleKzName = (arr, item, role) => {
  let nameClassState = false
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    filters: filterKzName(),
    filterMultiple: true,
    className: nameClassState ? 'filterDataClass' : '',
    filterMethod(value, row) {
      return row.sex === value
    },
    filterRemote(data) {
      if (data && data.length && data.length != 0) {
        kzCondition.mutations.setFilterSql({
          name: 'info.SEX',
          data
        })
        nameClassState = true
      } else {
        kzCondition.mutations.setFilterSql(false, {
          name: 'info.SEX'
        })
        nameClassState = false
      }
      window.vue.$bus.emit('pull-kz-data')
    },
    render: (h, params) => {
      if (params.row.kzname) {
        return h('render-name', {
          props: {
            kzName: params,
            encryption: ifEncryption(params.row),
          },
        })
      }
    }
  })
}

//处理老客姓名
const handleOldKzName = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    render: (h, params) => {
      let encryption = ifEncryption(params.row)
      if (params.row['oldkzname']) {
        if (encryption) {
          return h('span', {}, dataDst(params.row['oldkzname']))
        } else {
          return h('span', {}, params.row['oldkzname'])
        }
      }
    }
  })
}


//处理老客电话
const handleOldKzPhone = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    render: (h, params) => {
      let encryption = ifEncryption(params.row)
      if (params.row['oldkzphone']) {
        if (encryption) {
          return h('span', {}, dataDst(params.row['oldkzphone']))
        } else {
          return h('span', {}, params.row['oldkzphone'])
        }
      }
    }
  })
}

//获取拍摄类型
const getTypeData = () => {
  let typeData = []
  user.state.pageDict.commonMap.commonType.map(item => {
    typeData.push({
      value: item.dicCode,
      label: item.dicName,
    })
  })
  return typeData
}

//处理拍摄类型
const handleTypeName = (arr, item) => {
  let typeClassName = false
  arr.push({
    title: '拍摄类型',
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'info.TYPEID',
    filters: getTypeData(),
    className: typeClassName ? 'filterDataClass' : '',
    filterMethod(value, row) {
      return row.typeid === value
    },
    filterRemote(data) {
      if (data && data.length && data.length != 0) {
        kzCondition.mutations.setFilterSql({
          name: 'info.TYPEID',
          data
        })
        typeClassName = true
      } else {
        kzCondition.mutations.setFilterSql(false, {
          name: 'info.TYPEID'
        })
        typeClassName = false
      }
      window.vue.$bus.emit('pull-kz-data');
    },
    render: (h, params) => {
      let row = params.row
      let arr = []
      let src = kzWrodBook.shotType[row['typeid']].src
      let WeddingName = shotData.get(params.row.typeid) ? shotData.get(params.row.typeid).dicName : ''
      arr.push(h('img', {
        attrs: {
          src,
          title: WeddingName
        },
        style: {
          height: '18px',
          'margin-right': '4px',
          'vertical-align': 'middle',
          cursor: 'pointer',
        }
      }))
      arr.push(h('span', {
        style: {
          'vertical-align': 'middle',
        }
      }, WeddingName))
      return h('div', arr)
    }
  })
}

// 处理婚期时间
const handleMarryTime = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    render: (h, params) => {
      if (params.row.marrytime == 0) {
        return h('span', '')
      }
      let dicName = user.state.pageDict.commonMap.marryTime.find(v => v.dicCode == params.row.marrytime)
      return h('span', dicName.dicName)
    }
  })
}

// 处理预拍时间
const handleYpTime = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    render: (h, params) => {
      if (params.row.yptime == 0) {
        return h('span', '')
      }
      let dicName = user.state.pageDict.commonMap.ypTime.find(v => v.dicCode == params.row.yptime)
      return h('span', dicName.dicName)
    }
  })
}

//处理备注
const handleMemo = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    render: (h, params) => {
      return h('render-memo', {
        props: {
          encryption: ifEncryption(params.row),
          memo: params.row.memo,
          memoImg: params.row.talkimg,
          kzId: params.row.kzid,
          customWidth: parseInt(item.width),
        }
      })
    }
  })
}

//处理咨询类型
const handleZxStyle = (arr, item) => {
  let zxClassState = false
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'det.ZXSTYLE',
    filters: filterZxStyle(),
    filterMultiple: true,
    className: zxClassState ? 'filterDataClass' : '',
    filterMethod(value, row) {
      return row.zxstyle === value
    },
    filterRemote(data) {
      if (data && data.length && data.length != 0) {
        kzCondition.mutations.setFilterSql({
          name: 'det.ZXSTYLE',
          data
        })
        this.zxClassState = true
      } else {
        kzCondition.mutations.setFilterSql(false, {
          name: 'info.ZXSTYLE'
        })
        this.zxClassState = false
      }
      window.vue.$bus.emit('pull-kz-data')
    },
    render: (h, params) => {
      if (params.row.zxstyle || params.row.zxstyle == '0') {
        let name = ''
        user.state.pageDict.commonMap.zxStyle.forEach(item => {
          if (parseInt(item.dicCode) === parseInt(params.row.zxstyle)) {
            name = item.dicName
          }
        })
        return h('span', {}, name)
      }
    }
  })
}


//处理推广姓名
const handleCollectorName = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'info.COLLECTORID',
    filterMethod(value, row) {
      return row.collectorid === value
    },
    filterRemote(data) {
      window.vue.$bus.emit(window.vue.$route.meta.pathName + 'FilterRemote', {
        label: 'extend',
        value: data
      });
    },
    render(h, params) {
      return h('business', {
        props: {
          userInfo: {
            staffId: params.row.collectorid,
            name: params.row[item.key],
            kzId: params.row.kzid
          },
        }
      })
    }
  })
}

//处理 客服组
const handleDeptsort = (arr, item) => {
  let groupClass = false
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'info.GROUPID',
    filters: serviceGroupData,
    className: groupClass ? 'filterDataClass' : '',
    filterMethod(value, row) {
      return row.appointid === value
    },
    filterRemote(data) {

      if (data && data.length && data.length != 0) {
        //因为这个是字符串类型的，所以要前后加双引号
        let fData = data.map(item => {
          return '"' + item + '"';
        })

        kzCondition.mutations.setFilterSql({
          name: 'info.GROUPID',
          data: fData
        })
        groupClass = true
      } else {
        kzCondition.mutations.setFilterSql(false, {
          name: 'info.GROUPID'
        })
        groupClass = false
      }
      window.vue.$bus.emit('pull-kz-data');
    },
    render: (h, params) => {
      return h('span', {}, params.row.groupname)
    }
  })
}

//处理客服姓名
const handleAppointName = (arr, item) => {
  let appiont = false
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'info.APPOINTORID',
    filters: serviceData,
    className: appiont ? 'filterDataClass' : '',
    filterMethod(value, row) {
      return row.appointid === value
    },
    filterRemote(data) {
      if (data && data.length && data.length != 0) {
        kzCondition.mutations.setFilterSql({
          name: 'info.APPOINTORID',
          data
        })
        appiont = true
      } else {
        kzCondition.mutations.setFilterSql(false, {
          name: 'info.APPOINTORID'
        })
        appiont = false
      }
      window.vue.$bus.emit('pull-kz-data');
    },
    render: (h, params) => {
      if (params.row.appointname) {
        return h('business', {
          props: {
            userInfo: {
              staffId: params.row.appointorid,
              name: params.row[item.key],
              kzId: params.row.kzid,
              iconType: params.row['allottype']
            },
          }
        })
      }
    },
  })
}

//处理拍摄地
const handleShopName = (arr, item) => {
  arr.push({
    title: '门店',
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'info.SHOPID',
    // filters: item.filters,
    // filterMultiple: true,
    filterMethod(value, row) {
      return row.shopid === value
    },
    filterRemote(data) {
      window.vue.$bus.emit(window.vue.$route.meta.pathName + 'FilterRemote', {
        label: 'shop',
        value: data
      });
    },
  })
}

//处理客资状态
const handleStatusName = (arr, item, role) => {
  let classState = false
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'info.STATUSID',
    filters: filterStatus(item.key, role),
    filterMultiple: true,
    className: classState ? 'filterDataClass' : '',
    filterMethod(value, row) {
      return row.statusid === value
    },
    filterRemote(data) {
      if (data && data.length && data.length != 0) {
        kzCondition.mutations.setFilterSql({
          name: 'info.STATUSID',
          data
        })
        classState = true
      } else {
        kzCondition.mutations.setFilterSql(false, {
          name: 'info.STATUSID'
        })
        classState = false
      }
      window.vue.$bus.emit('pull-kz-data');
    },
    render(h, params) {
      let rowPushRole = user.state.pageDict.sourceMap[params.row.sourceid].pushRule
      if (user.state.pageDict.statusMap[params.row.statusid]) {
        if ((user.state.roleType === 'dsyy' || user.state.roleType === 'msjd') && params.row.statusid == 3) {
          return h('render-contact', {
            props: {
              rowData: params.row,
            }
          })
        } else if ((user.state.roleType === 'dsyy' || user.state.roleType === 'zjsyy') && params.row.statusid == 12 && rowPushRole == 13) {
          return h('render-draw', {
            props: {
              rowData: params.row,
              statusName: user.state.pageDict.statusMap[params.row.statusid].statusName,
            }
          })
        } else {
          return h('span', {}, user.state.pageDict.statusMap[params.row.statusid].statusName)
        }
      }
    }
  })
}

//处理订单时间
const handleSuccessTime = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    render(h, params) {
      if (parseInt(params.row.successtime)) {
        return (h('span', {}, timeUtil.getDate(params.row.successtime)))
      }
    }
  })
}

//处理下次追踪时间
const handleTracetimeTime = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'info.TRACETIME',
    render(h, params) {
      if (parseInt(params.row.tracetime)) {
        return (h('span', {}, timeUtil.getDate(params.row.tracetime)))
      }
    }
  })
}

//处理付款方式
const handlePlayStyel = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    render(h, params) {
      let palyStyle = new Map()
      PageDict.state.pageDict.commonMap.payStyle.map(item => {
        palyStyle.set(`${item.dicCode}`, item)
      })
      let text = params.row.paystyle && palyStyle.get(params.row.paystyle) ? palyStyle.get(params.row.paystyle).dicName : ''
      if (params.row.paystyle) {
        return h('span', text)
      }
    }
  })
}

//处理套系金额
const handleAmount = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'det.AMOUNT',
    render(h, params) {
      if (params.row.amount && params.row.amount !== "0") {
        let encryption = ifEncryption(params.row)
        if (encryption) {
          return h('span', {}, dataDst(params.row.amount))
        } else {
          if (params.row.orderimg) {
            return h('span', {
              class: {
                hoverIconKz: true
              },
              style: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }
            }, [
              h('span', {
                style: {
                  width: '180px',
                  height: '30px',
                  lineHeight: '30px',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                }
              }, params.row.amount),
              h('span', {
                on: {
                  click: () => {
                    document.getElementById('modalImgUrl').src = params.row.orderimg
                    document.getElementById('modalImg').style.display = 'block'
                    document.getElementById('modalImg').onclick = () => {
                      document.getElementById('modalImgUrl').src = ''
                      document.getElementById('modalImg').style.display = 'none'
                    }
                  },
                }
              }, [
                h('Icon', {
                  attrs: {
                    title: "点击查看大图"
                  },
                  style: {
                    marginTop: '3px',
                    cursor: 'pointer',
                  },
                  props: {
                    type: 'image',
                    size: '20',
                    color: '#5cadff'
                  },
                })
              ])
            ])
          } else {
            return h('span', {}, [
              h('span', {
                style: {
                  float: 'left'
                }
              }, params.row.amount),
            ])
          }
        }
      }
    }
  })
}

//处理已收金额
const handleStayAmount = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'det.STAYAMOUNT',
    render(h, params) {
      if (params.row.amount && params.row.amount !== "0") {
        let encryption = ifEncryption(params.row)
        if (encryption) {
          return h('span', {}, dataDst(params.row.stayamount))
        } else {
          return h('span', {}, [
            h('span', {
              style: {
                float: 'left'
              }
            }, params.row.stayamount),
          ])
        }
      }
    }
  })

}

//处理创建时间
const handleCreateTime = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'info.CREATETIME',
    render(h, params) {
      if (parseInt(params.row.createtime)) {
        return (h('span', {}, timeUtil.getDate(params.row.createtime)))
      }
    }
  })
}

//处理进店时间
const handleComeshopTime = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'info.CREATETIME',
    render(h, params) {
      if (parseInt(params.row.comeshoptime)) {
        return (h('span', {}, timeUtil.getDate(params.row.comeshoptime)))
      }
    }
  })
}

//处理领取时间
const handleReceiveTime = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'info.RECEIVETIME',
    render(h, params) {
      if (parseInt(params.row.receivetime)) {
        return (h('span', {}, timeUtil.getDate(params.row.receivetime)))
      }
    }
  })
}

//处理最后操作时间
const handleUpdateTime = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'info.UPDATETIME',
    render(h, params) {
      if (parseInt(params.row[item.key])) {
        return h('span', {}, timeUtil.getDate(params.row[item.key]))
      }
    }
  })
}

//预约时间
const handleappintTime = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'info.APPOINTTIME',
    render(h, params) {
      if (parseInt(params.row[item.key])) {
        return h('span', {}, timeUtil.getDate(params.row[item.key]))
      }
    }
  })
}

//处理地址
const handleAddress = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,

  })
}

//处理订单编号
const handleHtnum = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    sortable: 'custom',
    sortKey: 'det.HTNUM',
  })
}

//处理其他类型
const handleElse = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
  })
}

//处理地域
const handleAreaId = (arr, item) => {
  arr.push({
    title: item.title,
    width: parseInt(item.width),
    key: item.key,
    ellipsis: true,
    render: (h, params) => {
      if (parseInt(params.row.attrid)) {
        return h('span', attrData.get(params.row.attrid).dicName)
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/util.js